import { StatusPill } from '@/components/ui/StatusPill';
import { useI18n } from '@/hooks/useI18n';
import { formatDate } from '@/lib/format';
import { researchRequests } from '../data';

export const RequestsTable = () => {
  const { t, locale } = useI18n();

  return (
    <table className="data-table">
      <thead>
        <tr>
          <th scope="col">{t('table.code')}</th>
          <th scope="col">{t('table.topic')}</th>
          <th scope="col">{t('table.direction')}</th>
          <th scope="col">{t('table.owner')}</th>
          <th scope="col">{t('table.status')}</th>
          <th scope="col">{t('table.updated')}</th>
        </tr>
      </thead>
      <tbody>
        {researchRequests.map((request) => (
          <tr key={request.id}>
            <td>{request.code}</td>
            <td>{request.topic}</td>
            <td>{t(request.direction)}</td>
            <td>{request.owner}</td>
            <td>
              <StatusPill status={request.status} />
            </td>
            <td>{formatDate(request.updatedAt, locale)}</td>
          </tr>
        ))}
      </tbody>
    </table>
  );
};
